import { useRef, useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './RouteProgressBar.css';
import { handlePathnameCommit, installRouteProgressObserver } from '../lib/routeProgress';

const RouteProgressBar = () => {
  const location = useLocation();
  const isFirstMount = useRef(true);
  const previousPathnameRef = useRef(location.pathname);

  useEffect(() => {
    const cleanup = installRouteProgressObserver();
    return cleanup;
  }, []);

  useLayoutEffect(() => {
    const previousPathname = previousPathnameRef.current;
    previousPathnameRef.current = location.pathname;

    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }

    handlePathnameCommit(previousPathname, location.pathname);
  }, [location.pathname]);

  return null;
};

export default RouteProgressBar;
